export interface Showable {
  toggle: () => void;
  showing: boolean;
}

export const defaultShowable: Showable = {
  toggle: () => {},
  showing: true,
};
